import {
  fetchTokens,
  startListening,
  socketConnected,
} from '@bonanza-social/toolkit/state';
import { Notification, RewardType } from '@bonanza-social/rewards';

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      (notification: Notification) => {
        const { rewards } = notification;

        if (rewards.some((reward) => reward.rewardType === RewardType.Tokens)) {
          dispatch(fetchTokens());
        }
      },
    );
  },
});
